import apiClient from "./client";

export async function fetchBorrowers(skip = 0, limit = 50, kycStatus) {
  const params = { skip, limit };
  if (kycStatus) {
    params.kyc_status = kycStatus;
  }
  const { data } = await apiClient.get("/borrowers", { params });
  return data;
}

export async function fetchBorrower(borrowerId) {
  const { data } = await apiClient.get(`/borrowers/${borrowerId}`);
  return data;
}

export async function updateBorrower(borrowerId, payload) {
  const { data } = await apiClient.patch(`/borrowers/${borrowerId}`, payload);
  return data;
}

export async function fetchKycDashboard(kycStatus) {
  const params = {};
  if (kycStatus) {
    params.kyc_status = kycStatus;
  }
  const { data } = await apiClient.get("/borrowers/kyc/dashboard", { params });
  return data;
}

export async function createIndividualBorrower(payload) {
  const { data } = await apiClient.post("/borrowers/individual", payload);
  return data;
}

export async function createBusinessBorrower(payload) {
  const { data } = await apiClient.post("/borrowers/business", payload);
  return data;
}

export async function verifyBorrowerKyc(borrowerId, status, notes) {
  const { data } = await apiClient.post(`/borrowers/${borrowerId}/kyc/verify`, { status, notes });
  return data;
}

export async function submitBorrowerForKycReview(borrowerId) {
  const { data } = await apiClient.post(`/borrowers/${borrowerId}/kyc/submit-for-review`);
  return data;
}

export async function fetchBorrowerDocuments(borrowerId) {
  const { data } = await apiClient.get(`/borrowers/${borrowerId}/documents`);
  return data;
}

export async function uploadBorrowerDocument(borrowerId, documentType, file) {
  const formData = new FormData();
  formData.append("document_type", documentType);
  formData.append("file", file);
  const { data } = await apiClient.post(`/borrowers/${borrowerId}/documents`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function downloadBorrowerDocument(borrowerId, documentId) {
  return apiClient.get(`/borrowers/${borrowerId}/documents/${documentId}/download`, {
    responseType: "blob",
  });
}

export async function recordBorrowerConsent(borrowerId, consentType) {
  const { data } = await apiClient.post(`/borrowers/${borrowerId}/consents`, {
    consent_type: consentType,
    granted: true,
    policy_version: "1.0",
  });
  return data;
}

export async function grantRequiredConsents(borrowerId) {
  await recordBorrowerConsent(borrowerId, "data_processing");
  await recordBorrowerConsent(borrowerId, "crb_check");
}

export async function fetchGuarantorsDashboard() {
  const { data } = await apiClient.get("/borrowers/guarantors/dashboard");
  return data;
}

export async function fetchBorrowerGuarantors(borrowerId) {
  const { data } = await apiClient.get(`/borrowers/${borrowerId}/guarantors`);
  return data;
}

export async function createGuarantor(borrowerId, payload) {
  const { data } = await apiClient.post(`/borrowers/${borrowerId}/guarantors`, payload);
  return data;
}

export async function registerGuarantorWithDocuments(borrowerId, payload, documentFiles = []) {
  const formData = new FormData();
  formData.append("full_name", payload.full_name);
  formData.append("phone", payload.phone);
  if (payload.nida_number) {
    formData.append("nida_number", payload.nida_number);
  }
  formData.append("consent_granted", String(Boolean(payload.consent_granted)));
  formData.append("liability_disclosure_ack", String(Boolean(payload.liability_disclosure_ack)));
  for (const { documentType, file } of documentFiles) {
    formData.append("files", file);
    formData.append("document_types", documentType);
  }
  const { data } = await apiClient.post(`/borrowers/${borrowerId}/guarantors/register`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function uploadGuarantorDocument(borrowerId, guarantorId, documentType, file) {
  const formData = new FormData();
  formData.append("document_type", documentType);
  formData.append("file", file);
  const { data } = await apiClient.post(
    `/borrowers/${borrowerId}/guarantors/${guarantorId}/documents`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return data;
}

export async function updateGuarantor(borrowerId, guarantorId, payload) {
  const { data } = await apiClient.patch(`/borrowers/${borrowerId}/guarantors/${guarantorId}`, payload);
  return data;
}

export async function fetchCollateralDashboard() {
  const { data } = await apiClient.get("/borrowers/collateral/dashboard");
  return data;
}

export async function fetchBorrowerCollateral(borrowerId) {
  const { data } = await apiClient.get(`/borrowers/${borrowerId}/collateral`);
  return data;
}

export async function createCollateral(borrowerId, payload) {
  const { data } = await apiClient.post(`/borrowers/${borrowerId}/collateral`, payload);
  return data;
}

export async function updateCollateral(collateralId, payload) {
  const { data } = await apiClient.patch(`/borrowers/collateral/${collateralId}`, payload);
  return data;
}
